"use client";

import { c as _c } from "react/compiler-runtime";
import { type RefObject, useEffect } from "react";
import { loadGsapWithScrollTrigger, shouldReduceMotion } from "@/lib/gsap";
export function useCTAContactTeamAnimation(sectionRef) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== sectionRef) {
    t0 = () => {
      if (shouldReduceMotion()) {
        return;
      }
      let cleanup;
      let cancelled = false;
      const setupAnimation = async function setupAnimation() {
        const {
          gsap,
          ScrollTrigger
        } = await loadGsapWithScrollTrigger();
        if (cancelled || !sectionRef.current) {
          return;
        }
        const ctx = gsap.context(() => {
          const cta = sectionRef.current?.querySelector(".why-flowlab-cta");
          const footer = sectionRef.current?.querySelector(".why-flowlab-footer");
          const elements = [cta, footer].filter(_temp);
          gsap.set(elements, {
            opacity: 0,
            y: 28,
            filter: "blur(8px)"
          });
          gsap.to(elements, {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 0.85,
            ease: "power3.out",
            stagger: 0.08,
            scrollTrigger: {
              trigger: sectionRef.current,
              start: "top 80%",
              toggleActions: "play reverse restart reverse"
            }
          });
        }, sectionRef);
        ScrollTrigger.refresh();
        cleanup = () => ctx.revert();
      };
      setupAnimation();
      return () => {
        cancelled = true;
        cleanup?.();
      };
    };
    t1 = [sectionRef];
    $[0] = sectionRef;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}
function _temp(element) {
  return Boolean(element);
}